import { StoredData } from './types';

const _LOCAL_STORAGE_KEY = 'reliv.cookie-notice.v3';

const _DEFAULT_SETTINGS: StoredData = {
    cookiesAccepted: false,
};

export function setCookiesAccepted(cookiesAccepted: boolean) {
    const storedData: StoredData = {
        ...JSON.parse(localStorage.getItem(_LOCAL_STORAGE_KEY)),
        cookiesAccepted,
    };
    localStorage.setItem(_LOCAL_STORAGE_KEY, JSON.stringify(storedData));
}

export function getCookiesAccepted() {
    const storedData: StoredData
        = JSON.parse(localStorage.getItem(_LOCAL_STORAGE_KEY))
        || _DEFAULT_SETTINGS;
    return storedData.cookiesAccepted;
}
